import { CampaignControlOptionApiGroup } from '@/Enums/ControlOptions/CampaignGroup.enum';
import { IControlOption, IGroupedControlOption } from '@/Interfaces/ControlOption.interface';
import { IDv360InsertionOrder } from '@/Interfaces/DV360/InsertionOrder.interface';

export const mapGoogleCampaigns = (campaigns: IDv360InsertionOrder[]): IControlOption[] => {
  return campaigns
    ?.map(campaign => ({
      value: campaign.insertionOrderId,
      label: campaign.displayName,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const mapGroupedGoogleCampaigns = (
  campaigns: IDv360InsertionOrder[],
  groupValue?: string,
): IGroupedControlOption[] => {
  return campaigns
    ?.map(campaign => ({
      value: campaign.insertionOrderId,
      label: campaign.displayName,
      groupLabel: CampaignControlOptionApiGroup.Google,
      groupValue,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};
